module.exports = __webpack_public_path__ + "media/images/landing/crime/product-7-7b58ee59c93c74a6d9fb68b2c13e096a.png";